import { render, staticRenderFns } from "./TournamentRanking.vue?vue&type=template&id=3fae165c&scoped=true&"
import script from "./TournamentRanking.vue?vue&type=script&lang=js&"
export * from "./TournamentRanking.vue?vue&type=script&lang=js&"
import style0 from "./TournamentRanking.vue?vue&type=style&index=0&id=3fae165c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fae165c",
  null
  
)

export default component.exports